//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//theme
import { HeaderPage1 } from 'theme/elements/Headers';

export default function BalanceHeader() {
	const t = useAppSelector(selectTranslations);
	return (
		<HeaderPage1
			title={t('page.balance.add.digital.profile.title.main_title.text')}
			text={t('page.balance.add.digital.profile.title.main_title.description')}
		/>
	);
}
